import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';

import { Link } from '@bibliocommons/base-links';
import { availabilityShape, bibShape, catalogBibShape } from '@bibliocommons/bc-prop-types';
import { ModalHeader, ModalContent } from 'app/components/shared/Modal';
import Divider from 'app/components/bibs/shared/Divider';
import { bindAll } from '@bibliocommons/utils-react';

import ModalContainer from 'app/components/shared/Modal/ModalContainer';
import { FORMAT_CHOOSER_MODAL } from 'app/constants/BibConstants';
import BibManifestationInfo from '../BibManifestationInfo';

import './FormatChooserModal.scss';

export class FormatChooserModal extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  renderViewAllLink() {
    const { catalogBib, summary } = this.props;
    const searchQuery = `/v2/search?origin=core-holdings-explore&query=groupKey:${encodeURIComponent(
      summary.get('groupKey')
    )}&searchType=bl&title=${encodeURIComponent(catalogBib.getIn(['brief', 'title']))}`;

    return (
      <div className="view-all-link">
        {summary.get('editionsCount') > 1 && (
          <Link className="view-all-formats-editions-link" dataKey="view-all-formats-editions-link" href={searchQuery}>
            <FormattedMessage id="view_all_formats_and_edition" />
          </Link>
        )}
      </div>
    );
  }

  renderManifestations() {
    const { realtimeAvailabilities, catalogBib, handleClick } = this.props;

    const renderManifestationItem = manifestation => {
      const isMainBib = manifestation.get('id') === catalogBib.get('id');
      const availability = realtimeAvailabilities.get(manifestation.get('id'), manifestation.get('availability'));
      const key = `manifestation-link-${manifestation.get('id')}`;

      return (
        <Link
          className="manifestation-link"
          dataKey={key}
          key={key}
          href={`/v2/record/${manifestation.get('id')}`}
          handleClick={() => handleClick(manifestation)}
        >
          <BibManifestationInfo
            key={manifestation.get('id')}
            bib={manifestation}
            availability={availability}
            showPublicationDate={isMainBib}
            showCheckMark={isMainBib}
            showAvailability
          />
          <Divider />
        </Link>
      );
    };
    return this.props.manifestations.map(manifestation => renderManifestationItem(manifestation));
  }

  render() {
    return (
      <ModalContainer
        className="cp-format-chooser-modal"
        modalKey={FORMAT_CHOOSER_MODAL}
        handleClose={this.props.handleClose}
        size="small"
      >
        <ModalHeader title={<FormattedMessage id="select_a_format" />} />
        <ModalContent>
          <Divider />
          {this.renderManifestations()}
          {this.renderViewAllLink()}
        </ModalContent>
      </ModalContainer>
    );
  }
}

FormatChooserModal.propTypes = {
  catalogBib: catalogBibShape.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleClick: PropTypes.func.isRequired,
  manifestations: ImmutablePropTypes.listOf(bibShape).isRequired,
  realtimeAvailabilities: ImmutablePropTypes.mapOf(availabilityShape).isRequired,
  summary: ImmutablePropTypes.map.isRequired
};

export default FormatChooserModal;
